// Архетипы стратегического поведения ботов (см. developer_artifacts/bot_strategy_archetype.md)

export const BOT_ARCHETYPES = {
  AGGRESSIVE_RUSH: 'AGGRESSIVE_RUSH',
  AGGRESSIVE_BUILDUP: 'AGGRESSIVE_BUILDUP',
  DEFENSIVE: 'DEFENSIVE',
  ECONOMIC_POINTS: 'ECONOMIC_POINTS',
  ECONOMIC_COINS: 'ECONOMIC_COINS',
};

/**
 * Профиль архетипа параметризует оценочные функции бота:
 * - military / economy / keyPoint / influence — множители соответствующих групп весов;
 * - expansionRadius — максимальная дальность развития от стартового центрального квартала (null = без лимита);
 * - sizeHireMode — когда разрешен найм размера за монеты:
 *   'early' (с 1 раунда), 'defense-late' (только при обороне или с 10 раунда);
 * - earlyTempleAllowed — можно ли строить храм до появления путей влияния в ранней игре;
 * - buildupArmySize — суммарный размер армии, после которого BuildUp переходит к агрессии;
 * - captureEagerness — множитель ценности захвата городов.
 */
export const ARCHETYPE_PROFILES = {
  [BOT_ARCHETYPES.AGGRESSIVE_RUSH]: {
    military: 1.5,
    economy: 0.8,
    keyPoint: 1.2,
    influence: 0.6,
    expansionRadius: null,
    sizeHireMode: 'early',
    earlyTempleAllowed: false,
    buildupArmySize: 0,
    captureEagerness: 1.4,
  },
  [BOT_ARCHETYPES.AGGRESSIVE_BUILDUP]: {
    military: 1.3,
    economy: 1.0,
    keyPoint: 1.0,
    influence: 0.8,
    expansionRadius: null,
    sizeHireMode: 'defense-late',
    earlyTempleAllowed: false,
    buildupArmySize: 18,
    captureEagerness: 1.2,
  },
  [BOT_ARCHETYPES.DEFENSIVE]: {
    military: 1.0,
    economy: 1.2,
    keyPoint: 1.0,
    influence: 1.2,
    expansionRadius: 8,
    sizeHireMode: 'defense-late',
    earlyTempleAllowed: false,
    buildupArmySize: Infinity,
    captureEagerness: 0.5,
  },
  [BOT_ARCHETYPES.ECONOMIC_POINTS]: {
    military: 0.8,
    economy: 1.4,
    keyPoint: 1.2,
    influence: 1.5,
    expansionRadius: null,
    sizeHireMode: 'defense-late',
    earlyTempleAllowed: true,
    buildupArmySize: 22,
    captureEagerness: 0.8,
  },
  [BOT_ARCHETYPES.ECONOMIC_COINS]: {
    military: 0.8,
    economy: 1.4,
    keyPoint: 1.3,
    influence: 1.5,
    expansionRadius: null,
    sizeHireMode: 'defense-late',
    earlyTempleAllowed: false,
    buildupArmySize: 22,
    captureEagerness: 0.8,
  },
};

export const getArchetypeProfile = (archetype) => {
  return ARCHETYPE_PROFILES[archetype] || ARCHETYPE_PROFILES[BOT_ARCHETYPES.AGGRESSIVE_BUILDUP];
};
